module.exports = __webpack_public_path__ + "img/CS26Q-中_04.0da49204.jpg";